"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGrayRouteLogPage = getGrayRouteLogPage;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
function getGrayRouteLogPage(query) {
  return (0, _requestPIM.default)({
    url: '/grayRouteLog/page',
    method: 'get',
    params: query
  });
}